export type ServiceType = 'Hotel' | 'Flight' | 'Tour' | 'Activity' | 'Transfer' | 'Meal' | 'Cruise' | 'Visa' | 'Other';
export type ItineraryStatus = 'Draft' | 'Sent' | 'Approved';

export interface ItineraryService {
  id: string;
  type: ServiceType;
  name: string;
  time: string;
  description: string;
  costPrice: number;
  sellPrice: number;
  notes: string;
}

export interface ItineraryDay {
  id: string;
  dayNumber: number;
  date: string;
  location: string;
  accommodation: string;
  services: ItineraryService[];
}

export interface Itinerary {
  id: string;
  title: string;
  destination: string;
  startDate: string;
  endDate: string;
  nights: number;
  pax: number;
  currency: string;
  status: ItineraryStatus;
  linkedBooking: string;
  linkedCustomer: string;
  createdBy: string;
  createdAt: string;
  days: ItineraryDay[];
  coverImage: string;
}

export const serviceTypeConfig: Record<ServiceType, { icon: string; color: string; bg: string }> = {
  Hotel:    { icon: 'ri-hotel-line',           color: '#8B5CF6', bg: '#F5F3FF' },
  Flight:   { icon: 'ri-flight-takeoff-line',  color: '#0EA5E9', bg: '#F0F9FF' },
  Tour:     { icon: 'ri-map-2-line',           color: '#F59E0B', bg: '#FFFBEB' },
  Activity: { icon: 'ri-basketball-line',      color: '#10B981', bg: '#ECFDF5' },
  Transfer: { icon: 'ri-car-line',             color: '#6B7280', bg: '#F9FAFB' },
  Meal:     { icon: 'ri-restaurant-line',      color: '#F97316', bg: '#FFF7ED' },
  Cruise:   { icon: 'ri-ship-line',            color: '#3B82F6', bg: '#EFF6FF' },
  Visa:     { icon: 'ri-passport-line',        color: '#EF4444', bg: '#FEF2F2' },
  Other:    { icon: 'ri-more-line',            color: '#6B7280', bg: '#F9FAFB' },
};

export const itinerariesData: Itinerary[] = [];
